// src\themes\default\components\Marquee.tsx
type MarqueeItem = {
    title?: string;
};

type MarqueeData = {
    items?: MarqueeItem[];
    direction?: 'left' | 'right';
    speed?: 'slow' | 'normal' | 'fast';
};

const SPEED_MAP: Record<string, string> = {
    slow: '42s',
    normal: '28s',
    fast: '16s',
};

export default function Marquee({ data }: { data: MarqueeData }) {
    const items = data.items?.filter(i => i.title?.trim()) || [];
    if (!items.length) return null;

    const duration = SPEED_MAP[data.speed || 'normal'];
    const reverse = data.direction === 'right';

    return (
        <div className="col-span-12 border-y border-primary-200 py-6 select-none overflow-hidden">
            <div
                className="flex w-max animate-lino-marquee"
                style={{
                    animationDuration: duration,
                    animationDirection: reverse ? 'reverse' : 'normal',
                }}
            >
                {[0, 1].map(dup => (
                    <div key={dup} className="flex items-center shrink-0">
                        {items.map((item, i) => (
                            <span
                                key={i}
                                className="mx-8 text-xl lg:text-3xl font-primary-bold text-primary-900 tracking-tight whitespace-nowrap"
                            >
                                {item.title}
                                <span className="mx-8 text-primary-300">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}